import { useApiQuery } from '../useApiQuery'
import { keepPreviousData, UseQueryResult } from '@tanstack/react-query'
import * as api from '../api'
import { z } from 'zod'
import { zodDate } from '../../utilities/zodDate'

const participantDetail = {
  userUuid: z.string(),
  fullName: z.string(),
  completionPercentage: z.number().nullable(),
  completedAt: zodDate().nullable(),
  timeInvested: z.string().nullable(),
  status: z.string().nullable(),
}

const participantDetailParser = z.object(participantDetail)

export type ParticipantDetail = z.infer<typeof participantDetailParser>

export default function useGroupAssignmentParticipantsDetails(groupUuid: string, learningItemUuid: string) {
  const result: UseQueryResult<ParticipantDetail[]> = useApiQuery({
    queryKey: ['groupAssignmentParticipantsDetails', groupUuid, learningItemUuid],
    placeholderData: keepPreviousData,
    queryFn: async () =>
      z
        .array(participantDetailParser)
        .parse(
          await api.get(
            `group/${encodeURIComponent(groupUuid)}/${encodeURIComponent(learningItemUuid)}/participants-details`
          )
        ),
  })

  return result.data
}
